import React from 'react';
import HeroSection    from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import AboutSection   from '../components/sections/AboutSection';
import TeamSection    from '../components/sections/TeamSection';
import ContactSection from '../components/sections/ContactSection';

// ---- HomePage ----
// This page just assembles sections in order.
// To reorder sections → move the components below.
// To add a new section → create it in src/components/sections/ and import here.

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <TeamSection />
      <ContactSection />
    </main>
  );
}
